export default {
    'multiple-languages': {
        title: 'Wersja 2.3: Keybreak mówi w siedmiu językach',
        excerpt: 'Wersja 2.3 wprowadza obsługę wielu języków, cała aplikacja i strona internetowa są teraz dostępne w siedmiu językach, a kolejne są w drodze.',
    },
    'micro-breaks': {
        title: 'Wersja 2.2: mikroprzerwy',
        excerpt: 'Po opiniach użytkowników wersja 2.2 wprowadza mikroprzerwy: mały komunikat w narożniku ekranu co 10–15 minut z jedną rzeczą do wypróbowania.',
    },
    'dynamic-hold-system': {
        title: 'Wersja 2.1: mądrzejsze wytrzymania i lepsza informacja zwrotna',
        excerpt: 'Wersja 2.1 dodaje dwie rzeczy: możliwość wydłużenia czasu wytrzymania w trakcie ćwiczenia oraz nowy system animacji, który pokazuje dokładnie, na jakim etapie wytrzymania jesteś.',
    },
    'science-of-sitting': {
        title: 'Nauka o siedzącym trybie życia: co badania mówią o całodziennym siedzeniu',
        excerpt: 'Siedzący tryb życia to odrębne zagrożenie dla zdrowia, w dużej mierze niezależne od tego, czy ćwiczysz. Oto co naprawdę pokazują badania.',
    },
    'benefits-of-moving': {
        title: 'Dlaczego więcej ruchu w ciągu dnia pracy naprawdę ma znaczenie',
        excerpt: 'Regularne przerwy na ruch nie pomagają tylko ciału, sprawiają, że jesteś bardziej skupiony, mniej zmęczony i bardziej produktywny w skali dnia.',
    },
    'keybreak-launch': {
        title: 'Keybreak: poznaj swojego inteligentnego towarzysza przerw',
        excerpt: 'Po miesiącach pracy z radością ogłaszamy, że Keybreak jest już oficjalnie dostępny, bezpłatnie do pobrania na Maca i Windowsa.',
    },
}
